export default __webpack_public_path__ + "static/magento-6e878d773e83eaf743c077f0058d24bd.png";